import React from "react";
import { Link } from "react-router-dom";
import * as PR from "../../prime-modules/index";
import { PageNotFound } from "../../assets/images/index";

// Reuse Notfound.scss
import "../not-found/Notfound.scss";

const NoAccess = () => {
  return (
    <>
      <section className="notfound-section">
        <div className="grid grid-nogutter align-items-center custom-height">
          <div className="col-12 text-center">
            <PR.Image src={PageNotFound} alt="no access" className="notfound-img" />
            <h1 className="text-4xl font-semibold"> Access Denied </h1>
            <p className="text-xl mt-2 mb-4">You do not have permission to view this page.</p>
            <Link to="/" className="backtohome-btn"><i className="pi pi-chevron-left"></i> Back to home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NoAccess;
